import React from 'react';
import SocialMedia from './social-media/SocialMedia';
import AboutUs from './about-us/AboutUs';
import Help from './help/Help';
import General from './general/General';
import Account from './account/Account';
import Sites from './sites/Sites';

const Footer = () => {
  return (
      <div className="flex flex-col bg-neutral-100 dark:bg-dark-plus dark:dark-text border-t border-neutral-200 dark:border-neutral-700 pt-10">
        <div className="max-w-6xl mx-auto w-full flex flex-col md:flex-row md:flex-wrap justify-between items-center md:items-start gap-10 px-4 mb-10">
          <General />
          <Account />
          <Sites />
          <Help />
          <SocialMedia />
        </div>
        <AboutUs />
      </div>
  );
};

export default Footer;